import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  IUnitAreaAsset,
  IUnitAreaAssetsResponse,
} from 'src/services/api/UnitAreaAssets/apiContracts';
import { getAssetsBySuiteId, isApiError } from 'src/services/client';
import { toast } from 'react-toastify';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';

export const useUnitAreaAssets = () => {
  const user: any = useSelector(selectAuthenticatedUser);

  const [unitAreaAssets, setUnitAreaAssets] = useState<IUnitAreaAsset[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = async (suiteId) => {
    setLoading(true);

    try {
      const response: any = await getAssetsBySuiteId(
        suiteId,
        user?.id,
        user?.roles[0]?.role?.name
      );

      if (!response || isApiError(response)) {
        toast.error('Failed to load assets. Please try again.');
        return;
      }

      const { data }: IUnitAreaAssetsResponse = await response.json();

      const sorted: IUnitAreaAsset[] = (data || [])
        .slice()
        .sort((a: IUnitAreaAsset, b: IUnitAreaAsset) =>
          (a.name || '')
            .toLowerCase()
            .localeCompare((b.name || '').toLowerCase())
        );

      setUnitAreaAssets(sorted);
    } catch (err) {
      toast.error('An unexpected error occurred loading assets. Please try again.');
      console.error('Error fetching unit area assets:', err);
    } finally {
      setLoading(false);
    }
  };

  return {
    unitAreaAssets,
    fetchData,
    loading,
  };
};
